import {
  DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_BEGIN,
  DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_SUCCESS,
  DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_FAILURE,
  DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function syncMySqlDataSourceTables(args = {}) {
  return (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_BEGIN,
    });
    const { version, projectId, dbUuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/mysql/externalDb/${dbUuid}/sync-tables`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_SUCCESS,
            data: res,
          });
          toast.success('MySQL DataSource refreshed successfully !', {});
          resolve(res);
        },
        (err) => {
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed to refresh the MySQL DataSource.`, {});
          console.error('Failed:', errMsg);
          dispatch({
            type: DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSyncMySqlDataSourceTablesError() {
  return {
    type: DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        syncMySqlDataSourceTablesPending: true,
        syncMySqlDataSourceTablesError: null,
      };

    case DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_SUCCESS:
      // The request is success
      return {
        ...state,
        syncMySqlDataSourceTablesPending: false,
        syncMySqlDataSourceTablesError: null,
        mysqlExternalData: action.data,
      };

    case DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_FAILURE:
      // The request is failed
      return {
        ...state,
        syncMySqlDataSourceTablesPending: false,
        syncMySqlDataSourceTablesError: action.data.error,
      };

    case DATA_CONNECTOR_SYNC_MY_SQL_DATA_SOURCE_TABLES_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        syncMySqlDataSourceTablesError: null,
      };

    default:
      return state;
  }
}
